export default __webpack_public_path__ + "static/media/clientes5.3072c076.png";